import type { Page, UserListQuery } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../components/EmptyState';
import { ListSearch } from '../../components/ListSearch';
import type { ListQueryControls } from '../../lib/use-list-query';
import type { UserListItem } from './users.api';

interface UsersTableProps {
  page: Page<UserListItem>;
  columns: TableColumnsType<UserListItem>;
  list: ListQueryControls<UserListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function UsersTable({ page, columns, list, isRefreshing }: UsersTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search name, email or phone" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingUsers /> } : undefined}
        {...list.tableProps<UserListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingUsers() {
  return <EmptyState icon={SearchX} title="No matching users" description="No users match this search or these filters." />;
}
